<div *ngIf="loading" class="loading">{{ loadingText }}</div>
<div *ngIf="error" class="error-message">{{ error }}</div>

<div *ngIf="!loading && !error && !requisites" class="no-requisites">
  <p>{{ noRequisitesText }}</p>
</div>

<div *ngIf="!loading && !error && requisites" class="requisites-list">
  <div class="requisites-item" *ngIf="companyName">
    <span class="label">{{ t('requisites.companyName', 'Наименование компании') }}:</span>
    <span class="value">{{ companyName }}</span>
  </div>

  <div class="requisites-item">
    <span class="label">{{ binText }}:</span>
    <span class="value">{{ requisites.bin || '-' }}</span>
  </div>

  <div class="requisites-item">
    <span class="label">{{ legalAddressText }}:</span>
    <span class="value">{{ requisites.legalAddress || '-' }}</span>
  </div>

  <div class="requisites-item">
    <span class="label">{{ bankNameText }}:</span>
    <span class="value">{{ requisites.bankName || '-' }}</span>
  </div>

  <div class="requisites-item">
    <span class="label">{{ bikText }}:</span>
    <span class="value">{{ requisites.bik || '-' }}</span>
  </div>

  <div class="requisites-item" *ngIf="requisites.bankAccounts && requisites.bankAccounts.length > 0">
    <span class="label">{{ bankAccountsText }}:</span>
    <div class="value">
      <div *ngFor="let account of requisites.bankAccounts" class="account-line">
        {{ account.currency }}: {{ account.account }}
      </div>
    </div>
  </div>

  <div class="requisites-item">
    <span class="label">{{ signerPositionText }}:</span>
    <span class="value">{{ requisites.contractSignerPosition || '-' }}</span>
  </div>

  <div class="requisites-item">
    <span class="label">{{ signerNameText }}:</span>
    <span class="value">{{ requisites.contractSignerName || '-' }}</span>
  </div>
</div>
